import HeaderWithExportOptions from "components/HeaderWithExportOptions";

export const Header = ({ customers = [] }) => (<HeaderWithExportOptions
    title={'All Customers'}
/>)